<template>
  <div class="justify-center align-center">
    <span class="yc-icon-64 yc-icon-toast-check yc-icon--success-icon"></span><br/>
    <p class="pl-4 pr-4" style="    font-size: 20px;
    color: #6d7699;
    text-align: center;
    line-height: 20px;">
      The request to unlock the account has been sent to the admin, please wait a moment
    </p>

    <div class="d-flex justify-center login-btn-success">
      <div @click="goToLogin" class="input-icon" style="cursor: pointer">
        <span class="yc-icon yc-icon-back-arrow"></span>
      </div>
      <p @click="goToLogin" class="ml-1 login-text-btn">Back to login</p>
    </div>
  </div>
</template>

<script>
import Vue from "vue"

export default Vue.extend({
  name: "UnlockSuccess",
  methods: {
    goToLogin() {
      this.$router.push({path: "/login"});
    },
  }
})
</script>

<style scoped lang="scss">
.login-btn-success {
  position: absolute;
  bottom: 20%;
  right: 245px;
  cursor: pointer;
  font-size: 14px;
  color: #2E3653;
  font-weight: 600;
  &:hover {
    text-decoration: underline;
  }
}
</style>
